import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CardContent,
  Typography,
  Grid,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { DatePicker } from "@mui/x-date-pickers";
import { ExpandMore } from "@mui/icons-material";
import { Card } from "../style";
import { veicoloFields } from "../constants";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import CustomSelect from "../../../components/CustomSelect";
import { CustomSelectMenuProps } from "../../../../constants";
import { parseDate } from "../helpers";
import DynamicTable from "../dynamicTable";
import ComplexTable from "../complexTable";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";

function AccordionSection({ children, title, defaultExpanded = false }) {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h5">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}

const Spacer = styled.div(spacing);

function Overview({ dataset }) {
  const [datiVeicolo, setDatiVeicolo] = useState({});
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const Attestato = dataset["Attestato"];
  const Sinistri = dataset["sinistri"];
  const Veicolo = dataset["Veicolo"][0];
  const Propieta = dataset["Proprietà"];
  const Coperture = dataset["Coperture"];

  const getSelectOptions = (field) => {
    if (field.name === "tipoVeicolo") {
      if (!Veicolo.tipoVeicolo) return [];
      return Veicolo.tipoVeicolo.dataset;
    }
    return [];
  };

  useEffect(() => {
    setDatiVeicolo({ ...Veicolo, tipoVeicolo: Veicolo.tipoVeicolo.value });
  }, [Veicolo]);

  const handleChangeVeicolo = (fieldName, value) => {
    setDatiVeicolo((prev) => ({ ...prev, [fieldName]: value }));
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card mb={4}>
        <CardContent>
          <AccordionSection title={"Veicolo"} defaultExpanded={true}>
            <Grid container spacing={3}>
              {veicoloFields.map((field) => (
                <Grid item xs={12} sm={4} key={field.name}>
                  {field.type === "text" && (
                    <TextField
                      disabled={Boolean(Veicolo[field.name])}
                      label={field.label}
                      name={field.name}
                      value={datiVeicolo[field.name] || ""}
                      onChange={(e) =>
                        handleChangeVeicolo(field.name, e.target.value)
                      }
                      fullWidth
                      required={field.required}
                    />
                  )}

                  {field.type === "select" && (
                    <CustomSelect
                      disabled={Boolean(Veicolo[field.name])}
                      label={field.label}
                      name={field.name}
                      value={datiVeicolo[field.name] || ""}
                      onChange={(e) =>
                        handleChangeVeicolo(field.name, e.target.value)
                      }
                      options={getSelectOptions(field)}
                      fullWidth
                      MenuProps={CustomSelectMenuProps}
                      required={field.required}
                    />
                  )}

                  {field.type === "date" && (
                    <DatePicker
                      label={field.label}
                      value={
                        datiVeicolo[field.name]
                          ? dayjs(parseDate(datiVeicolo[field.name]))
                          : null
                      }
                      onChange={(date) => handleChangeVeicolo(field.name, date)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          required={field.required}
                          disabled={Boolean(Veicolo[field.name])}
                        />
                      )}
                      disableFuture
                      openTo="year"
                      views={["year", "month", "day"]}
                    />
                  )}
                </Grid>
              ))}
            </Grid>
          </AccordionSection>
        </CardContent>
      </Card>

      <Card mb={4}>
        <CardContent
          sx={{
            maxWidth: isMobile ? "calc(100vw - 40px)" : "100%",
            overflow: "auto",
          }}
        >
          <AccordionSection title={"Attestato"} defaultExpanded={true}>
            {Attestato && (
              <DynamicTable name={"Attestato"} dataset={Attestato} />
            )}
            <Spacer mb={6} />
            {Sinistri && (
              <Typography variant="h5" mb={6}>
                Sinistri
              </Typography>
            )}
            {Sinistri && <ComplexTable dataset={Sinistri} />}
          </AccordionSection>
        </CardContent>
      </Card>

      <Card mb={4}>
        <CardContent
          sx={{
            maxWidth: isMobile ? "calc(100vw - 40px)" : "100%",
            overflow: "auto",
          }}
        >
          <AccordionSection title={"Proprietà"} defaultExpanded={false}>
            {Propieta && <DynamicTable name={"Propieta"} dataset={Propieta} />}
          </AccordionSection>
        </CardContent>
      </Card>

      <Card>
        <CardContent
          sx={{
            maxWidth: isMobile ? "calc(100vw - 40px)" : "100%",
            overflowX: "auto",
          }}
        >
          <AccordionSection title={"Coperture"} defaultExpanded={false}>
            {Coperture && (
              <DynamicTable name={"Coperture"} dataset={Coperture} />
            )}
          </AccordionSection>
        </CardContent>
      </Card>
    </Box>
  );
}

export default Overview;
